import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../../store/auth';
import { useLanguage } from '../../contexts/LanguageContext';
import apiInstance from '../../utils/axios';
import HeroSection from './HeroSection';
import ProductCarousel from '../../components/ProductCarousel';
import CategoriesGrid from '../../components/CategoriesGrid';
import BrandCarousel from '../../components/BrandCarousel';
import TrustBadges from '../../components/TrustBadges';
import ViewAllProducts from '../../components/ViewAllProducts';
import SEO from '../../components/SEO';
import BannerDual from '@/components/commerce-ui/banner/BannerDual';
import Banner2Dual from '@/components/commerce-ui/banner/Banner2Dual';

const Home = () => {
  const { t } = useLanguage();
  const [isLoggedIn, user] = useAuthStore((state) => [
    state.isLoggedIn,
    state.user,
  ]);

  const [offersProducts, setOffersProducts] = useState([]);
  const [mostViewedProducts, setMostViewedProducts] = useState([]);
  const [popularProducts, setPopularProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllProducts = async () => {
      try {
        // Fetch all product carousels in parallel
        const [offersRes, viewedRes, popularRes] = await Promise.allSettled([
          apiInstance.get('ofertas-do-dia/'),
          apiInstance.get('produtos-mais-vistos/'),
          apiInstance.get('produtos-populares/'),
        ]);

        if (offersRes.status === 'fulfilled') {
          const data = offersRes.value.data.results || offersRes.value.data || [];
          setOffersProducts(data);
        }

        if (viewedRes.status === 'fulfilled') {
          const data = viewedRes.value.data.results || viewedRes.value.data || [];
          setMostViewedProducts(data);
        }

        if (popularRes.status === 'fulfilled') {
          const data = popularRes.value.data.results || popularRes.value.data || [];
          setPopularProducts(data);
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllProducts();
  }, []);

  return (
    <>
      <SEO 
        title="Vapes y Perfumes Árabes en Paraguay"
        description="ASMAR SHOP - Tu tienda de vapes, vaporizadores, pods desechables, e-liquids, perfumes árabes importados, oud, bakhoor y attar en Paraguay. Envíos a todo Paraguay y Brasil. ✓ Productos originales ✓ Mejores precios ✓ Atención por WhatsApp"
        keywords="vapes paraguay, perfumes árabes paraguay, vape shop asunción, pod desechable, e-liquid, oud perfume, bakhoor, attar, vaporizadores, tienda vape paraguay, asmar shop, perfumes importados, cigarrillos electrónicos, esencias árabes"
        url="https://asmarshop.com"
        type="website"
        includeOrganizationSchema={true}
      />
      <div className="min-h-screen bg-background">
        <main>
          {/* Hero Section with Carousel */}
          <HeroSection />

          {/* Offers of the Day */}
          <div className="mt-8 md:mt-12">
            <ProductCarousel
              title={t('offersOfTheDay')}
              products={offersProducts}
              badge={t('bestSellers') || 'IMPERDÍVEL'}
              loading={loading}
            />
          </div>

          {/* Banner 2 - Below Ofertas do Dia */}
          <div className="my-8 md:my-12">
            <Banner2Dual />
          </div>

          {/* Categories Grid */}
          <CategoriesGrid />

          {/* Most Viewed Products */}
          <ProductCarousel
            title={t('mostViewed')}
            products={mostViewedProducts}
            badge={t('trendingNow') ? null : 'MAIS VENDIDOS'}
            loading={loading}
          />

          {/* Brand Carousel */}
          <BrandCarousel />

          {/* Popular Products / Recommended */}
          <ProductCarousel
            title={t('popularProducts')}
            products={popularProducts}
            loading={loading}
          />

          {/* Promotional Banners - Side by Side */}
          <div className="my-8 md:my-12">
            <BannerDual />
          </div>

          {/* Trust Badges */}
          <TrustBadges />

          {/* View All Products CTA */}
          <ViewAllProducts />
        </main>
      </div>
    </>
  );
};

export default Home;
